import { useRequest } from 'ahooks'
import { Spin } from 'antd'
import { createStyles } from 'antd-style'
import { isNil } from 'lodash'

import { getFineURLApi } from '@eastcoal/api/third/fine/getFineURL'

import { DEFAULT_STALE_TIME } from '../../config/useRequest'
import { stringify } from '../../utils/querystring'

import { FineReportProps } from './interface'

const useStyles = createStyles(({ prefixCls }) => ({
  container: {
    width: '100%',
    height: '100%',
    [`.${prefixCls}-spin-container`]: {
      width: '100%',
      height: '100%'
    }
  },
  iframe: {
    width: '100%',
    height: '100%',
    border: 'none'
  }
}))

export const FineReport = ({
  className,
  style,
  filename,
  params
}: FineReportProps) => {
  const { cx, styles } = useStyles()

  const { data, loading } = useRequest(() => getFineURLApi({ filename }), {
    cacheKey: `getFineURL-${filename}`,
    staleTime: DEFAULT_STALE_TIME,
    refreshDeps: [filename],
    ready: !!filename
  })

  const search = isNil(params) ? '' : `&${stringify(params)}`

  return (
    <Spin
      classNames={{ root: styles.container }}
      description='加载中...'
      size='large'
      spinning={loading}
    >
      {!!data && (
        <iframe
          className={cx(styles.iframe, className)}
          src={`${data}${search}`}
          style={style}
          title='报表'
        />
      )}
    </Spin>
  )
}
